module.exports = __webpack_public_path__ + "media/KZ-MAN.235fab2b.ogg";